/**
 * Filters ArTable columns based on column-level visibility settings.
 *
 * A column is visible if:
 * - visibilityMode is 'internal' or undefined (show all columns)
 * - The column has no visibilityTypes defined (default visible)
 * - The column's visibilityTypes does not include 'hidden'
 * - The column's visibilityTypes includes the current visibilityMode
 */

import type { ArColumnDefinition } from '#types/System.Artifacts.types';
import type { VisibilityTypeId } from '#types/System.types';

type FilterVisibleColumnsParams = {
  columns: ArColumnDefinition[];
  visibilityMode: VisibilityTypeId | undefined;
};

function filterVisibleColumns({
  columns,
  visibilityMode,
}: FilterVisibleColumnsParams): ArColumnDefinition[] {
  if (!visibilityMode || visibilityMode === 'internal') return columns;

  return columns.filter((col) => {
    const columnVisibility = col.visibilityTypes;
    if (!columnVisibility?.length) return true;
    if (columnVisibility.includes('hidden')) return false;
    return columnVisibility.includes(visibilityMode);
  });
}

export { filterVisibleColumns };
